define([
	"dojo/_base/declare",
	"dijit/form/ToggleButton",
	"./_Plugin",
	"./util",
	"dojo/text!./resources/Button.html"
], function(declare,ToggleButton,_Plugin,util,template) {

	return declare([ToggleButton, _Plugin], {
		templateString: template,

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			if (shapes && shapes.length && this.editor.isSelectCanvasMode()) {
				this.set("checked", this.editor.canvasApp.selection.getCommonTextValue(shapes, this.cssValue, true), false);
			} else if (textAttrs) {
				this.set("checked", (textAttrs[this.pluginName] == this.cssValue) || (textAttrs[this.pluginName] == true), false);
			}
			return this.inherited(arguments);
		},

		/**
		 * Apply style
		 * @param  {Event} e
		 */
		onClick: function(e) {
			this.editor.setTextStyle(this.pluginName ,this.cssValue, this.checked);
		}
	});
});
